/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'faction/tetrarchy-small': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M24.5 7.5v17h-17v-17h17M25 7H7v18h18V7z"/><path pid="1" d="M16 2.707L29.293 16 16 29.293 2.707 16 16 2.707M16 2L2 16l14 14 14-14L16 2z"/><path pid="2" d="M10 12l4 4-3.999 4-4-4zM21.999 12.002l4 3.999L22 20l-4-4zM16.002 6l4 4-4 4-4-4zM16 18.001L20 22l-4 4L12 22z"/>'
  }
})
